<template>
    <div class="header">
        <nav class="navbar navbar-static-top" role="navigation" style="margin-bottom: 0">
            <div class="navbar-header clearfloat">
                <div class="nav-logo float-left clearfloat" id="logo-event">
                    <div class="dropdown profile-element">
                        <i class="logo">
                            <img class="logo-style" id="logo-img" :src="logoImageUrl" type="image/svg+xml"/>
                        </i>
                    </div>
                </div>

                <ul class="nav clearfloat float-left" id="side-menu">
                    <li class="float-left" v-if="token && isShow('/market')">
                        <router-link to="/market" :class="{'active_head': titleSelect == '/market'}"><span class="nav-label">行情</span></router-link>
                    </li>
                    <li class="float-left" v-if="token && isShow('/api')">
                        <router-link to="/api" :class="{'active_head': titleSelect == '/api'}" class="el-dropdown-link"><span class="nav-label" style="font-size: 13px">API</span></router-link>
                    </li>
                    <li class="about-event float-left about-us" v-if="token && isShow('/assets')">
                        <el-dropdown>
                            <router-link to="/assets" :class="{'active_head': titleSelect == '/assets'}"><span class="nav-label">权益</span></router-link>
                            <el-dropdown-menu slot="dropdown" class="dropdown_asset">
                                <el-dropdown-item>
                                    <router-link to="/assets/snapshot">
                                        <span class="nav-label">快照</span>
                                    </router-link>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </li>
                    <li class="float-left" v-if="token && isShow('/statistic')">
                        <router-link to="/statistic" :class="{'active_head': titleSelect == '/statistic'}" class="el-dropdown-link"><span class="nav-label" style="font-size: 13px">统计</span></router-link>
                    </li>
                    <li class="float-left" v-if="isShow('/task')">
                        <el-dropdown>
                            <router-link to="/task" :class="{'active_head': titleSelect == '/task'}" 
                            class="el-dropdown-link"><span class="nav-label" style="font-size: 13px">套利策略</span></router-link>
                            <el-dropdown-menu slot="dropdown" class="dropdown_tl">
                                <el-dropdown-item v-if="isShow('/task')">
                                    <router-link to="/task"
                                    ><span class="nav-label">任务</span></router-link>
                                </el-dropdown-item>
                                <el-dropdown-item  v-if="isShow('/config')">
                                    <router-link to="/config"
                                    ><span class="nav-label">配置</span></router-link>
                                </el-dropdown-item>
                                <el-dropdown-item  v-if="isShow('/demand')">
                                    <router-link to="/demand"
                                     class="el-dropdown-link"><span class="nav-label" style="font-size: 13px">需求</span></router-link>
                                </el-dropdown-item>
                                <el-dropdown-item  v-if="isShow('/strategy')">
                                    <router-link to="/strategy"
                                     class="el-dropdown-link"><span class="nav-label" style="font-size: 13px">策略</span></router-link>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </li>
                    <li class="float-left" v-if="isShow('/main/index')">
                        <el-dropdown>
                            <router-link to="/main/index/" :class="{'active_head': titleSelect == '/main/index/unilateral'}"
                            class="el-dropdown-link"><span class="nav-label" style="font-size: 13px">单边策略</span></router-link>
                            <el-dropdown-menu slot="dropdown" class="dropdown_s">
                                <el-dropdown-item v-if="isShow('/main/index/unilateral')">
                                    <router-link to="/main/index/unilateral" 
                                    ><span class="nav-label">策略</span></router-link>
                                </el-dropdown-item>
                                <el-dropdown-item  v-if="isShow('/main/index/api')">
                                    <router-link to="/main/index/api">
                                    <span class="nav-label" style="font-size: 13px">任务</span></router-link>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </li>
                    <li class="float-left" v-if="isShow('/main/mobile')">
                      <router-link to="/main/mobile" :class="{'active_head': titleSelect == '/main/mobile'}"><span class="nav-label">移动策略</span></router-link>
                    </li>
                    <li class="float-left" v-if="isShow('/main/tempStrategy')">
                        <router-link to="/main/tempStrategy" :class="{'active_head': titleSelect == '/main/tempStrategy'}"><span class="nav-label">临时策略</span></router-link>
                    </li>
                    <li class="float-left" v-if="isShow('/main/mill1')">
                        <router-link to="/main/mill1" :class="{'active_head': titleSelect == '/main/mill1'}"
                        class="el-dropdown-link"><span class="nav-label" style="font-size: 13px">矿机计算器</span></router-link>
                    </li>
                    <li class="float-left" v-if="isShow('/main/mill2')">
                        <router-link to="/main/mill2" :class="{'active_head': titleSelect == '/main/mill2'}"
                        class="el-dropdown-link"><span class="nav-label" style="font-size: 13px">矿机计算器(BTC)</span></router-link>
                    </li>
                    <li class="float-left" v-if="isShow('/coins')">
                        <router-link to="/coins" :class="{'active_head': titleSelect == '/coins'}"
                        class="el-dropdown-link"><span class="nav-label" style="font-size: 13px">代币列表</span></router-link>
                    </li>
                    <li class="float-left" v-if="isShow('/signal')">
                        <router-link to="/signal" :class="{'active_head': titleSelect == '/signal'}"
                        class="el-dropdown-link"><span class="nav-label" style="font-size: 13px">信号</span></router-link>
                    </li>
                    <li class="float-left" v-if="isShow('/simulate')">
                        <router-link to="/simulate" :class="{'active_head': titleSelect == '/simulate'}"
                        class="el-dropdown-link"><span class="nav-label" style="font-size: 13px">模拟交易</span></router-link>
                    </li>
                    <li class="float-left" v-if="isShow('/aveo')">
                        <router-link to="/aveo" :class="{'active_head': titleSelect == '/aveo'}"
                        class="el-dropdown-link"><span class="nav-label" style="font-size: 13px">aveo</span></router-link>
                    </li>
                    <li class="float-left">
                        <router-link to="/badata" :class="{'active_head': titleSelect == '/badata'}"
                            class="el-dropdown-link"><span class="nav-label" style="font-size: 13px">基础数据</span></router-link>
                    </li>
                    <li class="float-left">
                        <router-link to="/binance/trading" :class="{'active_head': titleSelect == '/binance/trading'}"
                            class="el-dropdown-link"><span class="nav-label" style="font-size: 13px">币安交易</span></router-link>
                    </li>
                </ul>
            </div>

            <div class="clearfloat">
                <ul class="nav navbar-top-links navbar-right float-right" id="nav-header">
                    <li class="float-right">
                        <router-link to="/login" class="dropdown-item register" data-toggle="modal" data-target="#registerModal" @click="registEvent()"
                         v-if="token == null && signatrue == ''">登录</router-link>
                        <a class="dropdown-item register" title="退出" @click="loginOut" v-else><i class="fa fa-sign-out" aria-hidden="true"></i></a>
                    </li>
                    <li class="user-name float-right">
                        <router-link to="/login" class="dropdown-item login" @click="loginEvent()"
                         v-if="token == null && signatrue == ''">立即注册</router-link>
                        <!-- <a class="dropdown-item login" v-else>{{userName}}</a> -->
                        <el-dropdown v-else>
                            <a class="dropdown-item login">{{userName}}</a>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="passwordDialog = true">修改密码</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </li>    
                </ul>
            </div>

        </nav>
        <el-dialog class="change-password-dialog" :visible.sync="passwordDialog" width="50%">
            <div class="dialog-title" style="padding: 10px;">
                <h3>修改密码</h3> 
            </div>
            <el-divider style="margin: 10px !important;"></el-divider>
            <el-form  :model="form" label-width="120px">
                <el-form-item label="原密码">
                    <el-input v-model="form.old" show-password></el-input>
                </el-form-item>
                <el-form-item label="新密码">
                    <el-input v-model="form.new" show-password></el-input>
                </el-form-item>
                <el-form-item label="再次输入">
                    <el-input v-model="form.reNew" show-password></el-input>
                </el-form-item>
            </el-form>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="passwordDialog = false">取 消</el-button>
                <el-button type="primary" @click="submitPassword">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
/* eslint-disable */
import Header from "@/components/header/Header.vue";
import Footer from "@/components/Footer/New-footer.vue";
import { mapState } from 'vuex'
import { get, post } from '@/api/index'

export default {
    data: function () {
        return {
            logoImageUrl: require('@/assets/img/lianghualogo.svg'),
            userData: {},
            token: null,
            titleSelect: this.$route.path,
            isSuper: sessionStorage.getItem('isSuper'),
            dropDownFlag: false,
            passwordDialog: false,
            form: {
                'old': '',
                'new': '',
                'reNew': ''
            },
            dialogWidth: '50%',
            userRouterPermission: this.$store.state.defaultPermission.concat(this.$store.state.userPermission ? this.$store.state.userPermission.column : [])
        }
    },
    watch: {
        $route: function () {
            this.titleSelect = this.$route.path;
        }
    },
    computed: {
        ...mapState([
            'userName',
            'signatrue',
        ]),
    },
    created() {
        
    },
    mounted() {
        this.loginToken();
        
        window.onresize = function() {
            let windowWidth = document.body.clientWidth;
            if (windowWidth < 800) {
                this.dialogWidth = '80%';
            } else if (windowWidth < 500) {
                this.dialogWidth = '100%';
            }

        }
    },
    methods: {
        // 登出
        loginOut() {
            var token_tl = this.$cookies.get('token');
            if (this.signatrue) {// 单边

            } else {
                var url =  this.$baseUrl + '/user/logout';
                var param = {
                    'token': token_tl
                };

                post(url, param).then(res => {
                    console.log(typeof res, res);
                    if (res.code == 200) {
                        this.$notify.info({
                            message: res.info,
                            title: '提示',
                            offset: 100
                        })
                    } else {
                        this.$notify.error({
                            message: res.info,
                            title: '提示',
                            offset: 100
                        })
                    }

                })
            }

            sessionStorage.removeItem('token');
            this.$cookies.remove('token');
            this.$cookies.remove('userName');
            this.$store.commit('getToken', '');

            this.$cookies.remove('tokenSig');
            this.$cookies.remove('level');
            this.$store.commit('setUnilateralSig', '');
            this.$store.commit('setUnilateralLevel', '');

            location.href = '/login'
        },

        loginToken() {
            var cookies_token = this.$cookies.get('token');
            if (cookies_token) {
                this.token = cookies_token;
            } else {
                this.token = sessionStorage.getItem('token');
            }
        },

        // 修改密码
        changePassword() {
            this.passwordDialog = !this.passwordDialog
        },

        // 提交修改密码
        submitPassword() {
            if (this.form.new !== this.form.reNew) {
                this.$notify.error({
                    message: '两次输入的密码不一致！',
                    title: '提示',
                    offset: 100,
                    duration: 1000
                })
                return
            }
            let url = this.$baseUrl + '/user/changepw'
            let param = {
                'token': this.token,
                'old_password': this.form.old,
                'new_password': this.form.new
            }
            post(url, JSON.stringify(param)).then(resp => {
                if (resp.code == 200) {
                    this.$notify.info({
                        message: '修改密码成功!',
                        title: '提示',
                        offset: 100,
                        duration: 1000
                    })
                    this.passwordDialog = false
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100,
                        duration: 1000
                    })
                }
            })
        },

        mouseHoverd(e) {
            var node = e.srcElement;
            var width_ = $(node).width()+68;
            var id_str = $(node).attr('aria-controls');
            var style_obj = {
                    width: width_,
                    'box-sizing': 'border-box',
                }
            if (id_str) {
                $('#'+id_str).css(style_obj)
            } else {
                var id_str_1 = $(node).parent().attr('aria-controls');
                $('#'+id_str_1).css(style_obj)
            }
            
            
        },
        isShow(router) {
            return this.userRouterPermission.find(element => element === router)
        }
    }
}
</script>

<style lang="scss">
    .el-popper[x-placement^=bottom] .popper__arrow::after {
        border-bottom-color: #2a2d2e; 
    }
    .el-popper[x-placement^=bottom] .popper__arrow {
        border-bottom-color: #484343;
    }
    .el-dropdown-menu {
        background-color: #2a2d2e;
        border-color: #2a2d2e;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 1);
        .el-dropdown-menu__item {
            text-align: center !important;
            a {
                color: #a8a7a9;
                display: inline-block;
                width: 100%;
            }
        }

        .el-dropdown-menu__item:hover{
            background-color: #646264;
        }
    }

    .dropdown_s {
        width: 120px;
        top: 20px;
    }
    .dropdown_tl {
        width: 120px;
        top: 20px;
    }
    .dropdown_asset {
        width: 94px;
        top: 20px;
    }

    .header{
        background-color: #1e1e1e;
        width: 100%;
        // position: fixed;
        // top: 0;
        height: 60px;
        z-index: 2060;

        .el-dropdown-menu__item {
            text-align: center;
        }
        
        nav{
            display: flex;
            justify-content: space-between;
            height: 100%;
            .navbar-header{
                margin-left: 15px;
                display: flex;
                align-items: center;
            }
            .el-divider{
                color: #a8a7a9;
            }
            #side-menu{
                font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
                font-weight: bolder;
                height: 100%;
                display: flex;
                align-items: center;
                li{
                    font-size: 14px;
                    a{
                        color: #a8a7a9;
                        text-decoration: none;
                        padding: 18px 34px;
                        outline: none;
                        span{
                            -webkit-text-size-adjust: none;
                        }
                    }
                    .task-dropdown {
                        position: absolute;
                        top: 65px;
                        list-style: none;
                        background-color: #1e1e1e;
                        box-shadow: 0 0 5px #fff;
                        li {
                            margin-left: 0;
                            padding: 2px 0;
                            a {
                                font-size: 12px;
                                color: #a8a7a9;
                            }
                        }
                        li:hover {
                            cursor: pointer;
                            background-color: #646264;
                            color: #fff;
                        }
                        
                    }
                }

                li:hover{
                    a{
                        color: #fff;
                        // background-color: #2a2d2e;
                        border-bottom: 1px solid #db5634;
                    }
                }
            }


            #nav-header{
                margin-right: 10px;
                display: flex;
                align-items: center;
                height: 100%;
                li{
                    padding: 5px;
                    line-height: 37px;
                    font-size: 13px;
                    a{
                        color: #a8a7a9;
                        padding: 10px 0 !important;
                        font-weight: 600;
                    }
                }
                li:hover{
                    cursor: pointer;
                    a{
                        color: #fff;
                    }
                }
            }
        }
    }
    #logo-event{
        margin-left: 10px;
        div{
            .logo-style{
                height: 42px;
            }
            .website{
                font-size: 12px;
                color: #fff;
            }
        }
    }
    .el-divider {
        margin: 10px 0;
    }
    .active_head{
        border-bottom: 1px solid #db5634;
        background-color: #2a2d2e;
    }
    .el-dialog {
        min-width: 360px !important;
        .el-dialog__header {
            background-color: #fff !important;
        }
        .el-dialog__body {
            .el-form {
                width: 360px;
                margin: 10px auto;
            }
            .change-password-box {
                .change-item {
                    margin-bottom: 10px;
                    label {
                        width: 80px;
                    }
                    input {
                        outline: none;
                        padding: 3px 3px;
                        border-radius: 2px;
                        border: 1px solid #d6d1d1;
                    }
                }
            }
        }
    }
    
    @media screen and (max-width: 1700px) {
        .header {
            width: 1300px;
            margin: auto;
        }
    }
</style>
